import * as dayjs from 'dayjs';

const advent = {
  //easter date Laurent Longre algorithm
  easter(Y) {
    let M=3, G= Y % 19+1, C= ~~(Y/100)+1, L=~~((3*C)/4)-12,
        E=(11*G+20+ ~~((8*C+5)/25)-5-L)%30, D;
    E<0 && (E+=30);
    (E==25 && G>11 || E==24) && E++;
    (D=44-E)<21 && (D+=30);
    (D+=7-(~~((5*Y)/4)-L-10+D)%7)>31 && (D-=31,M=4);
    return [Y, M, D];
  },

  holySaturday(year) {
    const tempDate = this.easter(year);
    const date = dayjs(`${tempDate[0]}/${tempDate[1]}/${tempDate[2]}`).subtract(1, 'd');
    return date;
  },

  goodFriday(year) {
    const tempDate = this.easter(year);
    const date = dayjs(`${tempDate[0]}/${tempDate[1]}/${tempDate[2]}`).subtract(2, 'd');
    return date;
  },

  holyThursday(year) {
    const tempDate = this.easter(year);
    const date = dayjs(`${tempDate[0]}/${tempDate[1]}/${tempDate[2]}`).subtract(3, 'd');
    return date;
  },

  palmSunday(year) {
    const tempDate = this.easter(year);
    const date = dayjs(`${tempDate[0]}/${tempDate[1]}/${tempDate[2]}`).subtract(7, 'd');
    return date;
  },

  ashWednesday(year) {
    const tempDate = this.easter(year);
    const date = dayjs(`${tempDate[0]}/${tempDate[1]}/${tempDate[2]}`).subtract(46, 'd');
    return date;
  },

  ascension(year) {
    const tempDate = this.easter(year);
    const date = dayjs(`${tempDate[0]}/${tempDate[1]}/${tempDate[2]}`).add(39, 'd');
    return date;
  },

  pentecost(year) {
    const tempDate = this.easter(year);
    const date = dayjs(`${tempDate[0]}/${tempDate[1]}/${tempDate[2]}`).add(49, 'd');
    return date;
  },
};

export default advent;
